<modal [name]="localStorageKeys.ti_modal_background_job_result" (closeOut)="onClose()" class="job-result-window">
  <modal-header>
    <span>{{strings.jobResult}}</span>
  </modal-header>
  <modal-body>
    <div *ngFor="let item of errors">
      {{strings.objNamePattern.replace('{0}', item.name)}}<br />{{strings.errorMessagePattern.replace('{1}', item.description)}}
      <hr align="center" width="90%" [size]="10 | tiPxToRem" color="#dddddd" /><br />
    </div>

    <div>
      <p class="job-result-text" *ngIf="text" [innerHTML]="text | tiSafeHtml"></p>

      <ng-container *ngIf="link">
        <p class="job-result-window-message">{{strings.availableFilesToDownload}}</p>
        <a class="card-link" target="_blank" [href]="link" (click)="onClose()" [title]="strings.download">{{strings.download}}</a>
      </ng-container>
    </div>
  </modal-body>
  <modal-actions>
    <button kendoButton (click)="onClose()">{{appStrings.close}}</button>
  </modal-actions>
</modal>
